import React, { useState } from 'react';
import { Filter, Check, ChevronDown, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface SupplierFilterProps {
  suppliers?: {
    name: string;
    count: number;
  }[];
  selectedSuppliers?: string[];
  onChange?: (suppliers: string[]) => void;
}
export function SupplierFilter({
  suppliers = [{
    name: 'Samsung',
    count: 45
  }, {
    name: 'Apple',
    count: 32
  }, {
    name: 'LG',
    count: 28
  }, {
    name: 'Sony',
    count: 15
  }, {
    name: 'Dell',
    count: 12
  }, {
    name: 'Electrolux',
    count: 10
  }, {
    name: 'Brastemp',
    count: 8
  }],
  selectedSuppliers = [],
  onChange
}: SupplierFilterProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<string[]>(selectedSuppliers);
  const [searchTerm, setSearchTerm] = useState('');
  const toggleSupplier = (name: string) => {
    const newSelected = selected.includes(name) ? selected.filter(s => s !== name) : [...selected, name];
    setSelected(newSelected);
    if (onChange) onChange(newSelected);
  };
  const clearFilters = () => {
    setSelected([]);
    if (onChange) onChange([]);
    setIsOpen(false);
  };
  const filteredSuppliers = suppliers.filter(s => s.name.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="relative" data-id="element-311">
      <button onClick={() => setIsOpen(!isOpen)} className={`flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all border ${selected.length > 0 ? 'bg-navy-50 text-navy-900 border-navy-200' : 'bg-white text-slate-600 border-slate-200 hover:border-navy-300'}`} data-id="element-312">
        <Filter className={`h-4 w-4 ${selected.length > 0 ? 'text-navy-900' : 'text-slate-400'}`} data-id="element-313" />
        <span data-id="element-314">
          {selected.length > 0 ? `${selected.length} Fornecedor${selected.length > 1 ? 'es' : ''}` : 'Fornecedores'}
        </span>
        <ChevronDown className="h-3 w-3 text-slate-400 ml-1" data-id="element-315" />
      </button>

      <AnimatePresence data-id="element-316">
        {isOpen && <>
            <div className="fixed inset-0 z-30" onClick={() => setIsOpen(false)} data-id="element-317" />
            <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: 10
        }} className="absolute top-full left-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-slate-200 z-40 flex flex-col max-h-[400px]" data-id="element-318">
              <div className="p-3 border-b border-slate-100" data-id="element-319">
                <input type="text" placeholder="Buscar fornecedor..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full px-3 py-1.5 bg-slate-50 border border-slate-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-navy-900" autoFocus data-id="element-320" />
              </div>

              <div className="overflow-y-auto flex-1 p-2 space-y-1" data-id="element-321">
                {filteredSuppliers.map(supplier => <button key={supplier.name} onClick={() => toggleSupplier(supplier.name)} className="w-full flex items-center justify-between px-2 py-2 hover:bg-slate-50 rounded-md text-sm group" data-id="element-322">
                    <div className="flex items-center" data-id="element-323">
                      <div className={`w-4 h-4 rounded border mr-3 flex items-center justify-center transition-colors ${selected.includes(supplier.name) ? 'bg-navy-900 border-navy-900' : 'border-slate-300 group-hover:border-navy-400'}`} data-id="element-324">
                        {selected.includes(supplier.name) && <Check className="h-3 w-3 text-white" data-id="element-325" />}
                      </div>
                      <span className="text-slate-700" data-id="element-326">{supplier.name}</span>
                    </div>
                    <span className="text-xs text-slate-400 bg-slate-100 px-1.5 py-0.5 rounded-full" data-id="element-327">
                      {supplier.count}
                    </span>
                  </button>)}

                {filteredSuppliers.length === 0 && <div className="p-4 text-center text-sm text-slate-400" data-id="element-328">
                    Nenhum fornecedor encontrado
                  </div>}
              </div>

              <div className="p-3 border-t border-slate-100 bg-slate-50 rounded-b-xl flex justify-between items-center" data-id="element-329">
                <button onClick={clearFilters} className="text-xs font-medium text-slate-500 hover:text-red-600 transition-colors" data-id="element-330">
                  Limpar filtros
                </button>
                <button onClick={() => setIsOpen(false)} className="text-xs font-bold text-navy-900 hover:text-navy-700" data-id="element-331">
                  Concluído
                </button>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </div>;
}